import { LegalEntity } from '@gozoki/api-types';
import { gozokiApiWithAuth } from '../gozokiApi';

export const getLegalEntities = async () => {
    const response = await gozokiApiWithAuth.get<LegalEntity[]>('/legal-entities');
    return response.data;
};
